var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6608 8.71289C13.1908 8.71289 11.9658 9.90289 11.9658 11.4079C11.9658 12.9129 13.1558 14.1029 14.6608 14.1029C16.1658 14.1029 17.3558 12.9129 17.3558 11.4079C17.3558 9.90289 16.1308 8.71289 14.6608 8.71289Z",
    fill: "#365644"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6606 0.488281C6.92564 0.488281 0.660645 6.75328 0.660645 14.4883C0.660645 22.2233 6.92564 28.4883 14.6606 28.4883C22.3956 28.4883 28.6606 22.2233 28.6606 14.4883C28.6606 6.75328 22.3956 0.488281 14.6606 0.488281ZM20.7856 21.8383C20.3656 21.8383 20.0156 21.4883 20.0156 21.0683C20.0156 18.1283 17.6006 15.7133 14.6606 15.7133C11.7206 15.7133 9.30564 18.1283 9.30564 21.0683C9.30564 21.4883 8.95564 21.8383 8.53564 21.8383C8.11564 21.8383 7.76564 21.4883 7.76564 21.0683C7.76564 18.1983 9.51565 15.7483 12.0006 14.6983C11.0206 13.9283 10.4256 12.7383 10.4256 11.4083C10.4256 9.06328 12.3156 7.13828 14.6606 7.13828C17.0056 7.13828 18.8956 9.02828 18.8956 11.3733C18.8956 12.7033 18.2656 13.8933 17.3206 14.6633C19.8056 15.7133 21.5556 18.1633 21.5556 21.0333C21.5556 21.4883 21.2056 21.8383 20.7856 21.8383Z",
    fill: "#365644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.6ed580c4c64a7e00bb9dfd7c082e785f.svg";
export { ForwardRef as ReactComponent };